<template>
  <a-card class="m-display-flex flex-column nowrap">
    <span slot="title">Create Other Income</span>
    <a-form class="margin-bottom" :form="form">
      <a-row :gutter="12">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
          <a-form-item label="Date">
            <a-date-picker
              placeholder="Select Date"
              disabled
              :format="getDefaultDateFormat"
              v-decorator="[
                'tanggal',
                {
                  rules: [{ required: true }],
                  initialValue: initialData.create_dt,
                },
              ]"
            />
          </a-form-item>
          <a-form-item label="Receive From">
            <a-input
              v-decorator="['receive_from', { rules: [{ required: true }] }]"
            ></a-input>
          </a-form-item>
          <a-form-item label="Value">
            <a-input-number
              class="m-width-full"
              :formatter="
                (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
              v-decorator="[
                'value',
                {
                  rules: [{ required: true }, { validator: checkMaxValue }],
                },
              ]"
            ></a-input-number>
          </a-form-item>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
          <a-form-item label="Currency">
            <a-select
              showSearch
              v-decorator="[
                'currency',
                {
                  rules: [{ required: true }],
                  initialValue: mataUang.mata_uang,
                },
              ]"
              @change="handleMataUang"
            >
              <a-select-option
                v-for="item in getAllMataUang"
                :key="item.code"
                :value="item.code"
                >{{ item.code }} - {{ item.currency }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="Description">
            <a-input
              v-decorator="['description', { rules: [{ required: true }] }]"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button
          :class="btnSaveLoading ? '' : 'padding-remove'"
          :loading="btnSaveLoading"
          type="primary"
          @click="save"
          >Save</a-button
        >
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "CreateOtherIncome",
  props: ["id", "type"],
  mixins: [CurrencyFormat, GlobalMethod],
  components: {},
  data() {
    return {
      postData: new FormData(),
      push: [],
      mataUang: {
        kurs: 1,
        estimate_value: 0,
        mata_uang: "IDR",
      },
      btnSaveLoading: false,
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getStandartFormatDate",
      "getDefaultDateFormat",
      "getAllMataUang",
    ]),
    initialData() {
      return {
        create_dt: moment(),
      };
    },
  },
  created() {
    this.fetchMataUang();
  },
  methods: {
    moment,
    submit() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        this.postData = new FormData();
        this.postData.append("tlc", this.getAuth.username);

        this.postData.append(
          "tanggal",
          moment(values.tanggal).format(this.getStandartFormatDate)
        );
        this.postData.append("receive_from", values.receive_from);
        this.postData.append("value", values.value);
        this.postData.append("currency", values.currency);
        this.postData.append("description", values.description);

        this.btnSaveLoading = true;

        axios({
          method: "post",
          url: this.$serviceUrl + "other_income",
          processData: false,
          data: this.postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-save");
            this.btnSaveLoading = false;
            this.$router.push({ name: "otherincome" });
          })
          .catch((err) => {
            let response = Object.assign({}, err.response);
            this.btnSaveLoading = false;
            this.displayMessageValue("error", response);
          });
      });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      let extension =
        file.name.substr(file.name.lastIndexOf(".")) == ".xls" ||
        file.name.substr(file.name.lastIndexOf(".")) == ".xlsx";
      if (extension) {
        if (FileSize > 2) {
          this.displayMessage("large-file-2mb");
        } else {
          this.push = [file];
          this.form.resetFields();
          return false;
        }
      } else {
        this.displayMessage("error-formatXls");
      }
    },
    handleRemove() {
      this.push = [];
    },
    save() {
      this.form.validateFields((err) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        this.confirmMessage("confirm-save");
      });
    },
    fetchMataUang() {
      this.$store.dispatch("FETCH_ALL_MATA_UANG");
    },
    handleMataUang(kurs) {
      this.mataUang.mata_uang = kurs;
      if (kurs == "IDR") {
        this.form.kurs = 1;
      } else {
        this.form.kurs = 1;
      }
    },
    checkMaxValue(rule, value, callback) {
      console.log(value)
      if (value <= 999999999999) {
        callback();
        return;
      }
      callback("Max. value 999.999.999.999!");
    },
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.submit);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.submit);
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
};
</script>

<style>
</style>